<template>
    <div class="col-12">
        <div class="text-left">
            <h3>{{ $t("pages.TopNews") }}</h3>
        </div>
        <hr/>
        <div class="row margin-lg-top">
            <featured-news-item :item="item" v-for="item in news.data" :key="'featured' + item.slug"/>
            <div class="col-md-3 col-sm-6 news">
                <iframe src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fdomankykolesarovej%2F&tabs=timeline%2C%20events&small_header=true&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                        width="auto" height="400" style="border:none;overflow:hidden;padding: 0" scrolling="yes" frameborder="0"
                        class="col" title="facebook-window"
                        allowTransparency="true" allow="encrypted-media"></iframe>
            </div>
        </div>
        <nav aria-label="Page navigation" class="text-center mt-5" v-if="news.last_page">
            <paginate
                    v-model="page"
                    :page-count="news.last_page"
                    :click-handler="changePage"
                    :prev-text="$t('button.Prev')"
                    :next-text="$t('button.Next')"
                    :page-class="'page-item'"
                    :container-class="'pagination justify-content-center'">
            </paginate>
        </nav>
    </div>
</template>

<script>
  import FeaturedNewsItem from './FeaturedNewsItem';
  import {ROUTER_NAMES} from '../../constants';
  import paginationMixin from '../../mixins/paginationMixin';

  export default {
    name: 'FeaturedNews',
    components: {FeaturedNewsItem},
    mixins: [paginationMixin],
    props: ['news', 'disabled'],
    data() {
      return {
        routeName: ROUTER_NAMES.HOME
      };
    },
  };
</script>

<style scoped>

</style>
